/** Rileva Safari desktop/iOS (esclude Chrome, Firefox, Edge su iOS). */
export function isSafariBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPR|OPiOS/i.test(ua);
}

/** Normalizza a YYYY-MM-DD o stringa vuota per input nativi / draft. */
export function normalizeIsoDateValue(value) {
  if (value == null || value === undefined) return "";
  const s = String(value).trim();
  if (!s) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** ISO → gg/mm/aaaa per visualizzazione Safari. */
export function isoToItalianDisplay(iso) {
  const n = normalizeIsoDateValue(iso);
  if (!n) return "";
  const [y, m, d] = n.split("-");
  return `${d}/${m}/${y}`;
}

/**
 * Testo gg/mm/aaaa → ISO o "" se vuoto; null se formato non valido.
 */
export function italianDisplayToIso(text) {
  const t = String(text ?? "").trim();
  if (!t) return "";
  const m = t.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
  if (!m) return null;
  const day = parseInt(m[1], 10);
  const month = parseInt(m[2], 10);
  const year = parseInt(m[3], 10);
  if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) {
    return null;
  }
  const probe = new Date(year, month - 1, day);
  if (
    probe.getFullYear() !== year ||
    probe.getMonth() !== month - 1 ||
    probe.getDate() !== day
  ) {
    return null;
  }
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
